import { Outlet } from 'react-router-dom';

import Header from 'components/Header';
import Footer from 'components/Footer';

function MainApp({ children = <Outlet /> }) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Header />
      <main className="flex flex-auto flex-col">{children}</main>
      <Footer />
    </div>
  );
}

export default MainApp;
